<template>
<v-container>
  <pre>
株式会社リネジェス（以下「当社」といいます。）は、適切な個人情報の取扱いのために、以下の事項を実施します。

1. お客様情報の保護についての考え方

    当社は、当社の業務を円滑に行うため、お客様の氏名、住所、電話番号、Eメールアドレス等の情報を収集・利用させていただいております。 当社は、これらのお客様の個人情報（以下「お客様情報」といいます。）の適正な保護を重大な責務と認識し、この責務を果たすために、個人情報保護方針を定め、本方針の下でお客様情報を取扱います。

2. 法令の遵守について

    お客様の個人情報の取扱いに関する日本の法令、国が定める指針及びその他の規範を遵守します。

3. 個人情報の適正な取得・保有・利用について

    個人情報の取得にあたっては、適法かつ公正な手段及び手続きによるものとし、取得した個人情報は、当社の業務運営上必要な範囲内で利用させていただきます。ご本人から書面等で直接お預かりする個人情報については、お預かりする時点で明示し同意をいただいた利用目的の範囲内で利用させていただきます。 それ以外の方法で取得した個人情報についても、次に掲げる事業活動における利用目的の範囲内でのみ保有し利用いたします。

    【事業活動】

・IoTを活用したスマートホーム及びスマート施設の提供
・IoTデバイスの企画、設計、開発及び販売
・エネルギー供給設備工事
・コンピュータシステムの企画、設計、開発、制作、販売業
・各種情報処理システムのソフトウェアの企画、設計、開発、販売
・各種IoTデバイスを利用する企画、開発、制作、管理及び運営ならびに受託、コンサルティング
・インターネットを利用した各種情報提供サービス業
・各種イベントの企画、運営、管理
・その他、前各号に附帯関連する一切の事業

    【利用目的】

・お客様の設備の利用状況（各センサーによる取得データも含みます）、料金、その他重要な情報を、郵便、電話、電子メール、お客様個人用 Web ページ等の手段によりお客様にお知らせするため
・当社または当社の代理店、業務委託先、業務提携先等において取扱う商品、サービスのご案内及びご提供のため
・IoTデバイス販売に関するサービス提供を行うために必要な範囲において、当社の業務委託先または業務提携先等と、お客様の契約情報、設備の利用状況、その他重要な情報を共有するため
・当社の業務委託先または業務提携先等において取扱う商品・サービス等あるいは各種イベント・キャンペーン等の開催について、郵便、電話、電子メール、お客様個人用 Web ページ等の手段によりご案内するため
・商品開発あるいは顧客満足度向上策検討のため、アンケート調査等を実施するため
・受託事業、関連事業のため
・当社ならびに当社の代理店、業務委託先、業務提携先等のサービス改善や新サービスの開発に役立てるため
・個人情報を集計・分析し、個人を識別することが出来ない統計データの作成、市場調査やデータ分析、新商品開発のため

    なお、当社は上記の業務を円滑に進めるため、口座振替先の金融機関、情報処理会社、協力会社（デベロッパー、ハウスメーカー、不動産会社、工事会社、運輸会社、保安会社等）に業務の一部を委託することがあります。 その際、当社からの業務委託先に、必要な範囲で個人情報を提供することがあります。 その場合、当社は業務委託先との間で個人情報取扱いに関する契約を結ぶ等、適切な監督を行います。

4. 個人情報の第三者提供について

    次のいずれかに該当する場合を除いて、個人情報を第三者に提供することはありません。

(1) ご本人の同意がある場合。
(2) 人の生命、身体または財産の保護のために必要な場合であって、緊急を要する等、ご本人の同意を得ることが困難である場合。
(3) 国の機関もしくは地方公共団体またはその委託を受けた者が、法令の定める事務を遂行することに対して協力する必要がある場合であって、ご本人の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがある場合。
(4) 利用目的の達成に必要な範囲内において、個人情報の取扱いを委託しまたは業務提携先等に情報共有・情報提供する場合
  例：お客様の与信判断及び契約後のお取引の参考にする場合。
(5) 設備のご利用者様とご契約者様が異なる場合（設備のご利用者様には設備稼働状況等のご利用情報を提供させていただきます。）
(6) その他法令等に基づき第三者に対する開示または提供が認められる場合。

5. 個人情報の開示・訂正・利用停止・消去等の求めについて

    当社が保有している個人情報に関する開示、内容の訂正、追加または削除、利用の停止、消去及び第三者への提供の停止等（以下「開示等」といいます。）をご希望される場合、お客様がご本人であることを当社の定める書面の提出により確認させていただき、速やかに開示に応じます。その請求手続き方法は、次の通りです。

(1) 「開示等の求め」の窓口
        ご請求は下記の窓口にて受付いたします。
        株式会社リネジェス
                所在地　東京都中央区銀座7丁目13-6サガミビル2F
(2) 手続き等
        上記のお求めに対し、所定の事項をご記入のうえ、本人であることを証明する書類( 運転免許証等の写し) を提出していただきます。また、代理人が「開示等の求め」を行う場合は上記にお問い合わせください。
(3) 手数料
        １項目あたり４００円（税別）
(4) 開示等の請求に関して取得した個人情報の取扱い
        開示等の請求に必要な範囲で取り扱います。提出いただいた書類は回答が終了した後、期限を定め廃棄処理させていただきます。
(5) 開示等の請求にお答えできない場合
        次のいずれかに該当する場合には、開示等のお求めにお答えできないことがあります。その場合は理由を回答いたします。
イ)本人確認のための書類に記載されている情報と当社の登録情報(クレジットカード名義等)が一致しない等、ご本人の確認ができない場合
ロ) 代理人による請求に際して、代理人のご本人確認ができない場合、または代理権が確認できない場合
ハ) 当社の定める手続きに従って開示のお申し出をいただけない場合
ニ) 開示の求めの対象が開示対象の個人情報に該当しない場合
ホ) ご本人または第三者の生命、身体、財産、その他の権利利益を害するおそれがある場合
ヘ） 当社の業務の適正な実施に著しい支障を及ぼすおそれがある場合
ト) 他の法令に違反することとなる場合

6. 的確管理・監査について

    取得したお客様の個人情報は、当社事業所において厳正な管理のもとで安全に蓄積・保管・廃棄をし、不正アクセス、紛失、破壊、改ざん及び漏洩等に対する防止措置を講じます。 また、不備が生じた場合、異常や危険な兆候が発見された場合は、速やかに是正措置を講じます。 併せて当社は、個人情報の取り扱いに関して、定期的に社内監査を行い、常に継続的改善に努めます。

2020年4月1日制定
</pre>
</v-container>
</template>

<script>
export default {
  name: 'Terms'
}
</script>

<style scoped>
pre {
  white-space: pre-wrap;
  /* Since CSS 2.1 */
  white-space: -moz-pre-wrap;
  /* Mozilla, since 1999 */
  white-space: -pre-wrap;
  /* Opera 4-6 */
  white-space: -o-pre-wrap;
  /* Opera 7 */
  word-wrap: break-word;
  /* Internet Explorer 5.5+ */
  line-height: 2em;
}
</style>



// WEBPACK FOOTER //
// src/components/common/Privacy.vue